import { Divider, Flex, PaperSection, SectionTitle } from '@shared/components';

import {
  BlocklistProctorInformationFields,
  type BlocklistProctorInformationFieldsProps,
} from '../blocklist-proctor-information-fields';
import {
  EmployeeInformationFields,
  type EmployeeInformationFieldsProps,
} from '../employee-information-fields';
import {
  ExamSessionInformationFields,
  type ExamSessionInformationFieldsProps,
} from '../exam-session-information-fields';
import { FileDocumentFields, type FileDocumentFieldsProps } from '../file-document-fields';

export interface BlockedCheaterFieldsProps {
  fields: EmployeeInformationFieldsProps['fields'] &
    BlocklistProctorInformationFieldsProps['fields'] &
    ExamSessionInformationFieldsProps['fields'] &
    FileDocumentFieldsProps['fields'];
  options?: BlocklistProctorInformationFieldsProps['options'];
  visibleFields?: EmployeeInformationFieldsProps['visibleFields'];
  slots?: BlocklistProctorInformationFieldsProps['slots'];
}

export default function BlockedCheaterFields(props: Readonly<BlockedCheaterFieldsProps>) {
  const { fields, options, visibleFields, slots } = props;

  return (
    <Flex sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(6) })}>
      <PaperSection title='ข้อมูลการระงับสิทธิ์สอบ'>
        <Flex
          sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(6), p: theme.spacing(6) })}
        >
          <SectionTitle title='Personal Information' />
          <EmployeeInformationFields fields={fields} visibleFields={visibleFields} />
        </Flex>
        <Divider />
        <BlocklistProctorInformationFields
          fields={fields}
          options={{ ...options, blockedUntilMode: 'date' }}
          slots={slots}
        />
        <Divider />
        <Flex
          sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(6), p: theme.spacing(6) })}
        >
          <SectionTitle title='Exam Session' />
          <ExamSessionInformationFields fields={fields} />
        </Flex>
        <Divider />
        <FileDocumentFields fields={fields} />
      </PaperSection>
    </Flex>
  );
}
